module.exports = __webpack_public_path__ + "img/mtt_1.1.fcb5623a.png";